import { createSelector } from '@reduxjs/toolkit';

import { B2BOrdersState, name } from '../reducers/b2bOrders';

export const getB2BOrdersSlice = (state): B2BOrdersState => state[name];

export const b2bOrdersSelector = createSelector(
  [getB2BOrdersSlice],
  ({ orders }) => orders
);

export const b2bOrdersFiltersSelector = createSelector(
  [getB2BOrdersSlice],
  ({ filters }) => filters
);

export const b2bOrdersMetaSelector = createSelector(
  [getB2BOrdersSlice],
  ({ meta }) => meta
);

export const b2bOrdersErrorSelector = createSelector(
  [getB2BOrdersSlice],
  ({ error }) => error
);

export const activeB2BOrderIdSelector = createSelector(
  [getB2BOrdersSlice],
  ({ activeOrderId }) => activeOrderId
);

export const activeB2BOrderSelector = createSelector(
  [getB2BOrdersSlice],
  ({ activeOrder }) => activeOrder
);

export const filteredB2BOrdersSelector = createSelector(
  [b2bOrdersSelector],
  (orders) => orders
);

export const isB2BOrdersLoadingSelector = createSelector(
  [getB2BOrdersSlice],
  ({ isLoading }) => isLoading
);

export const isB2BActiveOrderLoadingSelector = createSelector(
  [getB2BOrdersSlice],
  ({ isLoadingActiveOrder }) => isLoadingActiveOrder
);

export const isB2BOrderTouristSavingSelector = createSelector(
  [getB2BOrdersSlice],
  ({ isSavingTourist }) => isSavingTourist
);

export const deletingB2BOrderTouristIdSelector = createSelector(
  [getB2BOrdersSlice],
  ({ deletingTouristId }) => deletingTouristId
);

export const b2bOrderTouristMutationErrorSelector = createSelector(
  [getB2BOrdersSlice],
  ({ touristMutationError }) => touristMutationError
);
